import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

let lenis;

const SmoothScroll = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);
  useEffect(() => {
    const target = hash ? document.querySelector(hash) : null;
    if (target) lenis?.scrollTo(target, { offset: -80 });
    else lenis?.scrollTo(0, { immediate: true });
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll />
      <Nav />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
